import { render, staticRenderFns } from "./add-jewel-modal.vue?vue&type=template&id=163be595&scoped=true"
import script from "./add-jewel-modal.vue?vue&type=script&lang=js"
export * from "./add-jewel-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163be595",
  null
  
)

export default component.exports